import React from 'react';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { CreditsProvider } from '@atlassian/rovo-credits/credits-provider';
import type { CreditsErrorHandler } from '@atlassian/rovo-credits/credits-provider/types';
import { STATSIG_FEATURE_GATES } from '../../bootstrap/statsigFeatureGates';
import { useSite } from '../../hooks/useSite';
import { logError } from '../../utils/logger';

const reportCreditsError: CreditsErrorHandler = (error, context) => {
	logError({
		error,
		impact: 'Rovo credits session error',
		level: 'warning',
		tags: { creditsErrorContext: context },
	});
};

export const ExtensionCreditsProvider = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	const { site } = useSite();

	return (
		<CreditsProvider
			cloudId={site.workspace.cloudId}
			isRovoEnabled={FeatureGates.checkGate(STATSIG_FEATURE_GATES.UBP_ENFORCEMENT)}
			onError={reportCreditsError}
			product="rovo"
		>
			{children}
		</CreditsProvider>
	);
};
